import { SelectProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';

export const APPLICATION_ID_COLUMN = 'applicationId';
export const DATABASE_ID_COLUMN = 'databaseId';
export const EXCLUDED_APPLICATION_COLUMNS = ['serverIds', 'portfolioId', 'businessOwnerId', 'score', 'ranking', 'databaseMappings'];
export const EXCLUDED_DATABASE_COLUMNS = ['portfolioId', 'dbOwnerId', 'isSharedInfrastructure'];
export const EXCLUDED_SERVER_COLUMNS = [
    'portfolioId',
    'migrationPlanOverride',
    'ec2RecommendationOverrideOnPremCapacity',
    'ec2RecommendationOverridePeakUtilization',
    'ec2RecommendationOverrideAvgUtilization',
    'serverSupportId',
    'database',
    'databaseID',
    'databaseName',
    'databaseSizeGB',
    'databaseVersion',
    'databaseEngine',
    'isSharedInfrastructure'
];
export const EXCLUDED_SERVER_COMM_COLUMNS = ['portfolioId', 'communicationId', 'isSharedInfrastructure'];
export const EXCLUDED_APP_SERVER_COLUMNS = ['portfolioId', 'statusInGrouping'];
export const EXCLUDED_APP_DEPENDENCY_COLUMNS = ['portfolioId', 'status', 'resourceType', 'resourceId', 'applicationDependencyId'];
export const EXCLUDED_DB_APP_COLUMNS = ['portfolioId', 'statusInGrouping'];
export const FILTER_TOKEN_DISPLAY_LIMIT = 10;
export const SERVER_ID_COLUMN = 'serverId';

export enum ColumnOrderType {
    APPLICATION = 'application',
    APPLICATION_DEPENDENCY = 'applicationDependency',
    APPLICATION_SERVER = 'applicationServer',
    CONTACT_MANAGEMENT_APPLICATION = 'contactManagementApplication',
    CONTACT_MANAGEMENT_DATABASE = 'contactManagementDatabase',
    CONTACT_MANAGEMENT_SERVER = 'contactManagementServer',
    DATABASE = 'database',
    DATABASE_APPLICATION = 'databaseApplication',
    SERVER = 'server',
    SERVER_COMMUNICATION = 'serverCommunication',
}
export const columnOrder: { [key in ColumnOrderType]: string[] } = {
    [ColumnOrderType.APPLICATION]: [
        'groupName',
        'recordType',
        'applicationId',
        'ranking',
        'score',
        'name',
        'description',
        'businessUnit',
        'businessOwner',
        'businessOwnerEmail',
        'businessOwnerPhone',
        'technicalOwner',
        'technicalOwnerEmail',
        'technicalOwnerPhone',
        'serviceLevelAgreement',
        'applicationCriticality',
        'recoveryPointObjective',
        'recoveryTimeObjective',
        'regulations',
        'operatingHours',
        'numUsers',
        'userLocations',
        'isGeneratingRevenue',
        'usageCycle',
        'deploymentType',
        'maintenanceCycle',
        'lifecycleStatus',
        'disasterRecoveryPlan',
        'applicationType',
        'licenseRequirements',
        'numConnections',
        'inboundCommunicationPorts',
        'outboundCommunicationPorts',
        'reportingRequirements',
        '*',
        'inScope',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.APPLICATION_DEPENDENCY]: [
        'recordType',
        'srcAppId',
        'destAppId',
        'resourceType',
        'criticality',
        'status',
        '*',
        'inScope',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.APPLICATION_SERVER]: [
        'recordType', 'applicationId', 'serverId', 'Status', '*', 'inScope', 'createdAt', 'updatedAt'
    ],
    [ColumnOrderType.CONTACT_MANAGEMENT_APPLICATION]: [
        'applicationId',
        'name',
        'businessOwner',
        'businessOwnerEmail',
        'businessOwnerPhone',
        'businessUnit',
        'applicationType',
        'deploymentType',
        'lifecycleStatus',
        'regulations',
        'licenseRequirements',
        'reportingRequirements',
        '*',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.CONTACT_MANAGEMENT_DATABASE]: [
        'databaseId',
        'dbName',
        'dbInstanceName',
        'dbOwnerName',
        'dbOwnerEmail',
        'dbOwnerPhone',
        '*',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.CONTACT_MANAGEMENT_SERVER]: [
        'serverId',
        'server.hostName',
        'serverSupportName',
        'serverSupportEmail',
        'serverSupportPhone',
        'server.osName',
        'server.osVersion',
        'isPhysical',
        'server.hypervisor',
        'ipAddresses',
        'server.VMwareInfo.datacenterId',
        'server.VMwareInfo.manufacturer',
        '*',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.DATABASE]: [
        'recordType',
        'databaseId',
        'dbName',
        'dbInstanceName',
        'dbInstanceEngine',
        'dbInstanceVersion',
        'size',
        'serverId',
        'targetDBType',
        'deploymentPlan',
        'dbOwnerName',
        'dbOwnerEmail',
        'dbOwnerPhone',
        '*',
        'inScope',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.DATABASE_APPLICATION]: [
        'recordType',
        'databaseId',
        'applicationId',
        'criticality',
        '*',
        'inScope',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.SERVER]: [
        'recordType',
        'serverId',
        'migrationPlanOverride',
        'server.osName',
        'server.osVersion',
        'server.performance.numCpus',
        'server.performance.numCores',
        'server.performance.numThreads',
        'server.performance.totalRAMInKB',
        'server.performance.avgCpuUsagePct',
        'server.performance.maxCpuUsagePct',
        'maxRamUsagePct',
        'avgRamUsagePct',
        'isPhysical',
        'server.usagePct',
        'server.tenancy',
        'server.hypervisor',
        'server.targetHostType',
        'server.performance.totalDiskSizeInKB',
        'snapshotSizeInKB',
        'totalDiskUsagePct',
        'server.performance.maxDiskReadsPerSecondInKB',
        'server.performance.maxDiskWritesPerSecondInKB',
        'server.performance.maxDiskReadIOPS',
        'server.performance.maxDiskWriteIOPS',
        'server.performance.avgDiskReadIOPS',
        'server.performance.avgDiskWriteIOPS',
        'server.performance.avgDiskReadsPerSecondInKB',
        'server.performance.avgDiskWritesPerSecondInKB',
        'ipAddresses',
        'server.performance.avgFreeRAMInKB',
        'migrationPlan',
        'ec2InstancePreferences',
        'additionalAttribute1',
        'additionalAttribute2',
        'additionalAttribute3',
        'additionalAttribute4',
        'additionalAttribute5',
        'clusterName',
        'cpuSpeed',
        'server.cpuType',
        'server.VMwareInfo.datacenterId',
        'databaseID',
        'databaseName',
        'databaseSizeGB',
        'databaseVersion',
        'databaseEngine',
        'DBALeadEmail',
        'DBALead',
        'DBALeadPhone',
        'server.VMwareInfo.manufacturer',
        'server.performance.memoryReservation',
        'server.performance.avgNetworkReadsPerSecondInKB',
        'server.performance.avgNetworkWritesPerSecondInKB',
        'server.performance.maxNetworkReadsPerSecondInKB',
        'server.performance.maxNetworkWritesPerSecondInKB',
        'networkCardSpeeds',
        'server.networkInterfaceInfo',
        'server.networkInterfaceInfo.hasMoreValues',
        'server.performance.numNetworkCards',
        'reportingRequirements',
        'server.smBiosId',
        'server.configurationId',
        'server.connectorId',
        'server.VMwareInfo.hostId',
        'server.hostName',
        'serverSupportName',
        'serverSupportEmail',
        'serverSupportPhone',
        'server.performance.powerState',
        'server.performance.numDisks',
        'server.VMwareInfo.moRefId',
        'server.type',
        'server.VMwareInfo.toolsStatus',
        'server.VMwareInfo.vCenterId',
        'server.VMwareInfo.vCenterName',
        'server.VMwareInfo.vmFolderPath',
        'server.VMwareInfo.vmName',
        '*',
        'inScope',
        'createdAt',
        'updatedAt'
    ],
    [ColumnOrderType.SERVER_COMMUNICATION]: [
        'sourceServerId',
        'sourceProcessId',
        'sourceServerIPAddress',
        'sourceServerPort',
        'destinationServerId',
        'destinationProcessId',
        'destinationServerIPAddress',
        'destinationServerPort',
        'IPVersion',
        'protocol',
        'requestCount',
        'state',
        '*',
        'createdAt',
        'updatedAt'
    ]
};
export const BOOL_OPTIONS: SelectProps.Option[] = [
    { value: 'true', label: constants.TRUE },
    { value: 'false', label: constants.FALSE }
];

export const OVERSIZED_RESOURCE_THRESHOLDS = {
    [ColumnOrderType.APPLICATION]: 40000,
    [ColumnOrderType.SERVER]: 40000,
    [ColumnOrderType.DATABASE]: 40000, 
};
